<template>
  <form ref="form" class="dea-autosuggest-search-form" autocomplete="off" @submit.stop.prevent="searchForm">
    <Autosuggest
      :autosuggest="config"
      :show-header-top="false"
      :config="$root.config"
      component="custom"
      class="dea-input dea-autosuggest--in-page"
      :use-overlay="false"
      :filter-by-grade="false"
      placeholder="Inserisci il titolo del libro o l'ISBN"
      :results-component="BookSearchList"
      @close-search="$emit('close-search')"
    ></Autosuggest>
  </form>
</template>

<script>
/**
 * Component to search books on search API and present a list of titles / covers
 *
 *
 * ## Configuration
 *
 * Actual behavior is wrapped in a config object (usually in $root.config) with the following structure:
 *
 * - autosuggestUrl: API search URL
 * - initialStatus: "open" (fixed)
 * - isStaticSearch: false (fixed)
 * - linkBase: link to trigger for each book. The string "%(book)s" is replaced with book time_id
 * - linkTarget: window.open target
 *
 * ### Sample
 *
 * ```
 * ...
 * // Used for https://projects.invisionapp.com/d/main#/console/18047421/440394926/preview on "Richiedi copia digitale button"
 * evaluationSearch: {
 *   autosuggestUrl: "https://search.a.deascuola.it/v1/doc/live",
 *   initialStatus: "open",
 *   isStaticSearch: false,
 *   linkBase: `${SSO_URL}/#/user/landing/activate/%(book)s/evaluation1`,
 *   linkTarget: "_blank"
 * }
 * ```
 *
 * ## Usage
 *
 * Import component and declare in parent template passing the proper configuration.
 *
 * Example:
 *
 * ```
 * <template>
 *    <div>
 *      <SearchBookAutosuggest :config="$root.config.evaluationSearch" />
 *    <div>
 * </template>
 *
 *
 * import SearchBookAutosuggest from "~/components/books/components/SearchBookAutosuggest";
 * ```
 */
import Autosuggest from "@/components/patterns/Autosuggest";
import BookSearchList from "~/components/books/components/BookSearchList";

export default {
  name: "SearchBookAutosuggest",
  // eslint-disable-next-line vue/no-unused-components
  components: { BookSearchList, Autosuggest },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      BookSearchList,
    };
  },
  methods: {
    searchForm() {
      const bookId = document.getElementById("custom-search-input").value;
      window.open(this.config.linkBase.replace("%(book)s", bookId), this.config.linkTarget);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-autosuggest--in-page.dea-input {
  @include media("<=s") {
    width: 100%;
  }
  width: 50%;

  .dea-ico-ricerca {
    padding-left: 0;

    &::before {
      left: $space-base;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .autosuggest-search-input {
    padding-left: $space-large + $space-x-small;
  }

  .autosuggest-results-list {
    border: $border-light $dea-color-grey-medium;
  }

  .autosuggest-container-results {
    top: calc(100% - #{$space-small});
  }
}
</style>
